// extracted by mini-css-extract-plugin
module.exports = {"box":"index-page_box__3EEri","zag":"index-page_zag__2ynuI","item":"index-page_item__2e5TV"};